export default function CashbackCheck(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg id="CashbackCheckIcon" viewBox="0 0 17.996 13.419" {...props}>
            <defs>
                <linearGradient
                    id="prefix_cashback_check"
                    x1={1.146}
                    y1={0.216}
                    x2={0.091}
                    y2={1.072}
                    gradientUnits="objectBoundingBox"
                >
                    <stop offset={0} stopColor="#dc2765" />
                    <stop offset={0.981} stopColor="#32266f" />
                    <stop offset={1} stopColor="#1b2670" />
                </linearGradient>
            </defs>
            <path
                d="M6.112 17.733L.264 11.885a.9.9 0 010-1.272L1.536 9.34a.9.9 0 011.272 0l3.94 3.94 8.439-8.439a.9.9 0 011.272 0l1.272 1.272a.9.9 0 010 1.272L7.385 17.733a.9.9 0 01-1.273 0z"
                transform="translate(0 -4.577)"
                fill="url(#prefix_cashback_check)"
            />
        </svg>
    );
}
